import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { api, assetUrl } from "@/lib/api";
import { ExploreHeader } from "@/attendee/ExploreShared";
import { Compass, CalendarClock, Ticket } from "lucide-react";

export default function ExploreActivityDetail() {
  const { id } = useParams();
  const { eventId } = useApp();
  const [a, setA] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let active = true;
    setA(null); setErr(false);
    api.exploreExcursionDetail(eventId, id).then((d) => { if (active) setA(d); }).catch(() => { if (active) setErr(true); });
    return () => { active = false; };
  }, [eventId, id]);

  if (err) return <div className="pt-20 px-4"><div className="att-card p-8 text-center text-sm text-cream-dim">This excursion is no longer available.</div></div>;
  if (!a) return <div className="pt-20 px-4"><div className="h-48 att-card animate-pulse" /></div>;

  const scrollBooking = () => {
    const el = document.getElementById("booking-panel");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  return (
    <div className="pt-16 px-4 pb-8">
      <ExploreHeader eyebrow="Activities & Excursions" title={a.name} icon={a.image_url ? undefined : Compass} />

      {a.image_url && (
        <img
          src={assetUrl(a.image_url)}
          alt=""
          loading="lazy"
          decoding="async"
          className="h-44 w-full object-cover rounded-2xl mb-4"
        />
      )}

      {a.season_note && (
        <div className="att-card p-4 mb-3" data-testid="excursion-season-note">
          <div className="text-[11px] uppercase tracking-wide font-semibold text-cream-dim mb-1 inline-flex items-center gap-1.5"><CalendarClock className="h-3.5 w-3.5 text-[hsl(var(--pc-gold))]" /> Season</div>
          <p className="text-sm text-cream leading-relaxed">{a.season_note}</p>
        </div>
      )}

      <button onClick={scrollBooking} data-testid="excursion-prices-booking" className="w-full att-card p-3.5 flex items-center gap-3 mb-3 text-left focus-visible:ring-2 focus-visible:ring-[hsl(var(--pc-gold))] outline-none">
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-[hsl(var(--pc-gold)/0.16)] text-[hsl(var(--pc-gold))] border border-[hsl(var(--pc-gold)/0.3)]"><Ticket className="h-5 w-5" /></div>
        <div><div className="font-semibold text-cream">Prices & booking</div><div className="text-xs text-cream-dim">How to book this excursion</div></div>
      </button>

      {a.description && <p className="text-sm text-cream-dim leading-relaxed mb-3">{a.description}</p>}

      {a.booking_note && (
        <div id="booking-panel" className="att-card p-4 border-l-2 border-[hsl(var(--pc-gold))]" data-testid="excursion-booking-panel">
          <div className="text-[11px] uppercase tracking-wide font-semibold text-[hsl(var(--pc-gold))] mb-1">Prices & booking</div>
          <p className="text-sm text-cream leading-relaxed">{a.booking_note}</p>
        </div>
      )}
    </div>
  );
}
